import { render, staticRenderFns } from "./updatereport.vue?vue&type=template&id=484778b0&"
import script from "./updatereport.vue?vue&type=script&lang=js&"
export * from "./updatereport.vue?vue&type=script&lang=js&"
import style0 from "./updatereport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports